module.exports = __webpack_public_path__ + "static/media/4_NL.63fbc059.mp3";